import React from "react";
import "./main.css";
import Fade from "react-reveal/Fade";

function Ads() {
  return (
    <div className="pb-[3rem] !text-center">
      <Fade bottom opposite={true} exit={true}>
        <h2 className="font-bold lg:text-5xl md:text-3xl text-2xl my-2 title mb-[25px]   !leading-[140%] !text-center">
          <span className="text-pent">.Gold Domains </span>Marketplace
        </h2>
        <p className=" mx-auto text-base paragraph">
          Explore and purchase exclusive premium .gold domains perfectly
          tailored for businesses in the gold and jewelry ecosystem.
        </p>
      </Fade>
    </div>
  );
}

export default Ads;
